export const MuiInputLabel = {
  formControl: {
    position: 'relative' as const,
    top: 'auto',
    left: 'auto',
    fontSize: '0.8125rem',
    marginBottom: '3px',
    transform: 'none',
  },
  outlined: {
    transform: 'none',
    '&.MuiInputLabel-sizeSmall': {
      transform: 'none',
    },
  },
  filled: {
    transform: 'none',
    '&.MuiInputLabel-sizeSmall': {
      transform: 'none',
    },
  },
  sizeSmall: {
    transform: 'none',
  },
};
